import { combineReducers } from 'redux';
import Users from './Users/reducer';
import SDM17SPG from './SDM17SPG/reducer';
import SDM17DEC from './SDM17DEC/reducer';
import Projects from './Projects/reducer';
import Issues from './Issues/reducer';

export default combineReducers({
    Projects,
    Issues,
    Users,
    SDM17SPG,
    SDM17DEC
});



// WEBPACK FOOTER //
// ./environments/fhepool/data/reducer.js